import { Component, inject } from '@angular/core';
import { ToastNotify } from '@core';

@Component({
  selector: 'app-toast',
  imports: [],
  templateUrl: './toast.component.html'
})
export class Toast {
  toastService = inject(ToastNotify);

  readonly CheckCircle2 = 'solar:check-circle-bold';
  readonly XCircle = 'tabler:circle-x-filled';
  readonly XIcon = 'tabler:x';
  readonly MessageCircleWarningIcon = 'mdi:alert-circle';
  readonly InfoIcon = 'solar:info-circle-bold';
}
